/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { ShoppingAssistantProduct } from '../../shoppingAssistant';
import { ProductCard } from './ProductCard';

interface ProductCarouselProps {
    products: ShoppingAssistantProduct[];
    onAddToBasket?: (product: any) => void;
}

export const ProductCarousel: React.FC<ProductCarouselProps> = ({ products, onAddToBasket }) => {
    return (
        <div className="w-full overflow-x-auto pb-4 custom-scrollbar">
            <div className="flex gap-4 pr-4">
                {products.map((product) => (
                    <ProductCard
                        key={product.id}
                        product={product}
                        onAddToBasket={onAddToBasket}
                    />
                ))}
            </div>
        </div>
    );
};
